function RecurringTimer ( callback, delay, paused = false ) {
  let timerId = null;
  let start = null;
  let remaining = delay;

  this.pause = () => {
    window.clearTimeout( timerId );
    remaining -= new Date() - start;
  };

  const resume = () => {
    start = new Date();
    timerId = window.setTimeout( () => {
      remaining = delay;
      resume();
      callback();
    }, remaining );
  };

  this.resume = resume;

  this.resume();

  if ( paused ) {
    this.pause();
  }

  this.clear = () => {
    window.clearTimeout( timerId );
  };
}

export default RecurringTimer;
